import { useMemo } from "react"

import { fetchAllNotifications } from "@/api"
import { NotificationList } from "@/components/others/notification/notification-list"
import { GoBack } from "@/components/shared"
import { Sheet, SheetContent } from "@/components/ui"
import ScreenLayout from "@/layouts/screen"
import { useInfiniteScrollQuery } from "@/modules/helpers/hooks"
import { sendHaptic } from "@/modules/helpers/utils"

// Define filter map locally or import if shared. Since it's specific to view labels, keeping it here or passing as prop is fine.
const filterMap = {
  important: "Quan trọng",
  "new-campaign": "Chiến dịch mới",
  financial: "Thanh toán",
  zzp: "Cập nhật ZZP"
}

interface NotificationFilterViewProps {
  filter: string
  setFilter: (filter: string) => void
  isOpen: boolean
}

export const NotificationFilterView = ({
  filter,
  isOpen,
  setFilter
}: NotificationFilterViewProps) => {
  const { data, fetchNextPage, hasNextPage, isLoading, isFetchingNextPage, forceRefetch } =
    useInfiniteScrollQuery({
      queryKey: ["notification", filter],
      queryFn: fetchAllNotifications,
      params: {
        filter: filter || undefined,
        limit: 50
      }
    })

  const notifications = useMemo(() => {
    return data?.list || []
  }, [data?.list])

  const filterTitle = useMemo(() => {
    return filterMap[filter as keyof typeof filterMap] || "Gần đây"
  }, [filter])

  const handleRefresh = async () => {
    await forceRefetch?.()
  }

  return (
    <Sheet open={!!isOpen} modal>
      <SheetContent className="w-full !p-0 overflow-hidden" side="right" hiddenClose>
        <ScreenLayout transition="none">
          <div className="h-full flex flex-col overflow-hidden">
            {/* Header */}
            <div className="bg-white flex-shrink-0">
              <GoBack
                onClick={() => {
                  sendHaptic()
                  setFilter("")
                }}
                title={filterTitle}
              />
            </div>

            {/* Notifications List - Scrollable Area */}
            <div
              className="flex-1 overflow-y-auto bg-white"
              id="notification-filter-scroll-container"
            >
              <NotificationList
                notifications={notifications}
                isLoading={isLoading}
                hasNextPage={hasNextPage}
                isFetchingNextPage={isFetchingNextPage}
                fetchNextPage={fetchNextPage}
                onRefresh={handleRefresh}
                scrollableTargetIds="notification-filter-scroll-container"
                emptyMessage="Không có thông báo trong mục này."
              />
            </div>
          </div>
        </ScreenLayout>
      </SheetContent>
    </Sheet>
  )
}
